export default "/images/vendor/@coreui/icons/svg/flag/cif-az.svg?24589fcc0a0c24223f8308278f5a248c";